import React, { useState } from 'react';
import { useBrandingConfig } from '../BrandingConfigContext';
import AdminSidebar from './AdminSidebar';
import { Menu, X } from 'lucide-react';

function AdminLayout({
  children,
  user,
  pendingReportsCount = 0,
  onBackToMain,
  activeTab,
  onTabChange,
  pageTitle,
}) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { brandingConfig } = useBrandingConfig();

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  // Map active tab to section title
  const getSectionTitle = tab => {
    const titleMap = {
      reports: 'Report Management',
      archived: 'Archived Reports',
      moderation: 'Report Moderation',
      'extra-notes': 'Extra Notes Moderation',
      users: 'User Management',
      email: 'Email Management',
      config: 'System Configuration',
      'area-config': 'Area & Map Settings',
      'branding-config': 'Branding Configuration',
      'upload-config': 'Upload Settings',
      'map-config': 'Map Configuration',
      stats: 'System Statistics',
      'super-users': 'Super User Management',
      analytics: 'Analytics & Export',
      'database-management': 'Database Management',
      'error-logs': 'Log Viewer',
      'system-info': 'System Info',
    };
    return titleMap[tab] || 'Admin Panel';
  };

  return (
    <div className="flex h-screen bg-gray-50">
      {/* Sidebar */}
      <AdminSidebar
        isOpen={sidebarOpen}
        onClose={closeSidebar}
        activeTab={activeTab}
        onTabChange={onTabChange}
        user={user}
        pendingReportsCount={pendingReportsCount}
        onToggleSidebar={toggleSidebar}
      />

      {/* Main Content */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Admin Section Header */}
        <header className="bg-white shadow-md p-4">
          <div className="flex items-center justify-between">
            {/* Mobile Menu Button */}
            <button
              onClick={toggleSidebar}
              className="md:hidden p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100 transition-colors"
              aria-label="Toggle admin menu"
            >
              {sidebarOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>

            {/* Section Title */}
            <h1 className="text-xl font-bold text-primary-800">{getSectionTitle(activeTab)}</h1>

            {/* Spacer for mobile layout */}
            <div className="md:hidden w-10"></div>
          </div>
        </header>
        {/* Content Area */}
        <main className="flex-1 overflow-y-auto p-4 md:p-6">
          <div className="max-w-7xl mx-auto">{children}</div>
        </main>
      </div>
    </div>
  );
}

export default AdminLayout;
